import { render, staticRenderFns } from "./FirmaMagistrado.vue?vue&type=template&id=251ac71e"
import script from "./FirmaMagistrado.vue?vue&type=script&lang=js"
export * from "./FirmaMagistrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports